import { ElementType } from "react";
import call from "../../../public/contact/call.svg";
import email from "../../../public/contact/email.svg";

export const icons: { [key: string]: ElementType } = {
  call,
  email
};
